export default "__VITE_ASSET__dRthSy0v__"